/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BabylonSearchHandlerInfo } from '../models/BabylonSearchHandlerInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class BabylonSearchControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns BabylonSearchHandlerInfo OK
     * @throws ApiError
     */
    public getSearchHandler({
        term,
        filterBy = 'ALL',
    }: {
        term: string,
        filterBy?: 'TRANSACTION' | 'BLOCK' | 'FINALITY_PROVIDER' | 'ACCOUNT' | 'VALIDATOR' | 'TOKEN' | 'CONTRACT' | 'COVENANT_COMMITTEE' | 'RELAYER' | 'ALL',
    }): CancelablePromise<Array<BabylonSearchHandlerInfo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/search/handler',
            query: {
                'filterBy': filterBy,
                'term': term,
            },
        });
    }

}
